export const SITE = {
  name: "Sandstorm Trading",
  tagline: "Cards • Games • Collectibles",
  domain: "sandstormtcg.com",
  url: "https://sandstormtcg.com",
  established: 2025,
};

export const NAV_LINKS = [
  { id: "home", label: "Home", href: "#home" },
  { id: "shop", label: "Shop", href: "#shop" },
  { id: "carry", label: "What We Carry", href: "#carry" },
  { id: "about", label: "About", href: "#about" },
  { id: "follow", label: "Follow Us", href: "#follow" },
  { id: "contact", label: "Contact", href: "#contact" },
];

export const STORES = [
  {
    id: "tcgplayer",
    name: "TCGPlayer",
    badge: "Primary Store",
    primary: true,
    description: "Browse all the Trading Card Games we carry here.",
    cta: "Shop TCGPlayer",
    url: "https://sandstormtrading.tcgplayerpro.com/",
    handle: "sandstormtrading.tcgplayerpro.com",
  },
  {
    id: "manapool",
    name: "Mana Pool",
    badge: "Marketplace",
    description:
      "Find Sandstorm Trading listings on Mana Pool's collector-focused card marketplace.",
    cta: "Shop Mana Pool",
    url: "https://manapool.com/shop/sandstormtrading",
    handle: "manapool.com/shop/sandstormtrading",
  },
  {
    id: "ebay",
    name: "eBay",
    badge: "Marketplace",
    description:
      "Shop Sandstorm Trading cards and collectibles through our official eBay store.",
    cta: "Shop eBay",
    url: "https://www.ebay.com/str/sandstormtrading",
    handle: "ebay.com/str/sandstormtrading",
  },
  {
    id: "collx",
    name: "CollX",
    badge: "Marketplace",
    description:
      "Browse Sandstorm Trading cards on CollX, built for collectors on the go.",
    cta: "Browse CollX",
    url: "https://share.collx.app/sandstormtrading",
    handle: "share.collx.app/sandstormtrading",
  },
];

export const CATEGORIES = [
  { id: "mtg", code: "MTG", name: "Magic: The Gathering", note: "Singles, boosters & sealed", url: "https://sandstormtrading.tcgplayerpro.com/search/products?productLineName=Magic%3A%20The%20Gathering" },
  { id: "pokemon", code: "PKMN", name: "Pokémon", note: "Singles, boosters & sealed", url: "https://sandstormtrading.tcgplayerpro.com/search/products?productLineName=Pokemon" },
  { id: "lorcana", code: "LRC", name: "Disney Lorcana", note: "Singles & sealed product", url: "https://sandstormtrading.tcgplayerpro.com/search/products?productLineName=Disney%20Lorcana" },
  { id: "onepiece", code: "OP", name: "One Piece Card Game", note: "Singles & sealed product", url: "https://sandstormtrading.tcgplayerpro.com/search/products?productLineName=One%20Piece%20Card%20Game" },
  { id: "fab", code: "FAB", name: "Flesh and Blood", note: "Singles & sealed product", url: "https://sandstormtrading.tcgplayerpro.com/search/products?productLineName=Flesh%20and%20Blood%20TCG" },
  { id: "swu", code: "SWU", name: "Star Wars: Unlimited", note: "Singles & sealed product", url: "https://sandstormtrading.tcgplayerpro.com/search/products?productLineName=Star%20Wars%3A%20Unlimited" },
  { id: "sports", code: "SPRT", name: "Sports Cards", note: "Singles & collectibles", url: "https://www.ebay.com/str/sandstormtrading/Sports-Card-Singles/_i.html?store_cat=49492567018" },
  { id: "other", code: "ETC", name: "Other Cards & Collectibles", note: "Supplies, accessories & more", url: "https://www.ebay.com/str/sandstormtrading" },
];

export const SOCIALS = [
  {
    id: "instagram",
    name: "Instagram",
    handle: "@sandstormtrading",
    url: "https://www.instagram.com/sandstormtrading",
    blurb: "Card photos, new arrivals and shop updates.",
  },
  {
    id: "facebook",
    name: "Facebook",
    handle: "Sandstorm Trading",
    url: "https://www.facebook.com/people/Sandstorm-Trading/61589898719615/",
    blurb: "News, restocks and community updates.",
  },
  {
    id: "tiktok",
    name: "TikTok",
    handle: "@sandstorm.trading",
    url: "https://www.tiktok.com/@sandstorm.trading",
    blurb: "Pulls, packs and behind-the-scenes clips.",
  },
];

export const CONTACT = {
  email: "sandstormtradingva@gmail.com",
  heading: "Get in Touch",
  message:
    "Questions about an order, a specific card, or something you're hunting for? The fastest way to reach Sandstorm Trading is by email. You can also message us through any of our social channels.",
};
